import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionRequiredCondition, { ContinueConditionIcon } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"

import { getConditionByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type NoTagsIdentifiedConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	text: string
}

const NoTagsIdentifiedConditionSection: React.FC<NoTagsIdentifiedConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		text
	} = props

	const noTagsIdentifiedCondition = getConditionByValidationSlug("no-tags-identified", nextChatBotFlowBlockRules)

	if (!noTagsIdentifiedCondition) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={noTagsIdentifiedCondition.rule}
			>
				<BlockBodySectionRequiredCondition
					text={text}
					icon={<ContinueConditionIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default NoTagsIdentifiedConditionSection
